import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
export const GetOutOfScopeMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const OutOfScopeMessage = (param)=>{
    let { content, messageId, onSubmitFeedback, onDismissFeedback } = param;
    const { OutOfScopeMessageTID } = useMemo(()=>GetOutOfScopeMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": OutOfScopeMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: OutOfScopeMessageTID.Intro(),
                showWhiteSpaces: true,
                applyMarkdownBold: true,
                children: content.intro
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
